import { useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import {
  type FileType,
  useGenerateStatementModal,
} from '@/features/generate-statement';
import type { Language } from '@/shared/types';
import { isValid, parse } from 'date-fns';

export const useOpenStatementModalFromQuery = () => {
  const [searchParams] = useSearchParams();

  const { openGenerateStatementModal } = useGenerateStatementModal();

  const parseDate = (dateParam: string | null) => {
    if (!dateParam) {
      return undefined;
    }

    const date = parse(dateParam, 'M/d/yyyy', new Date());

    return isValid(date) ? date : undefined;
  };

  const { isModalShouldOpen, props } = useMemo(() => {
    const params = {
      dateFrom: parseDate(searchParams.get('dateFrom')),
      dateTo: parseDate(searchParams.get('dateTo')),
      fileType: searchParams.get('fileType') as FileType,
      lang: searchParams.get('lang') as Language,
    };

    const isStatementRoute = location.pathname.includes('/history/statement');

    const isModalShouldOpen =
      Object.values(params).every(
        value => value !== null && value !== undefined
      ) && isStatementRoute;

    return {
      isModalShouldOpen,
      props: params,
    };
  }, [searchParams]);

  useEffect(() => {
    if (isModalShouldOpen) {
      const { dateTo, dateFrom, lang, fileType } = props;
      openGenerateStatementModal({
        dateFrom: dateFrom,
        dateTo: dateTo,
        lang,
        fileType,
      });
    }
  }, [isModalShouldOpen, props]);
};
